import $ from 'jquery';

function completeAndRedirect(nextStep) {
  setTimeout(() => {
    window.location = nextStep;
  }, 2000);
}

document.addEventListener("turbo:load", function () {
  if ($("#telia_sign_signing_handler").length) {
    toggleTextAndButtonVisibility();

    let count = 0;
    const MAX_RETRIES = 1800; // 2 hours when invesment is valid
    const POLLING_INTERVAL = 4000;
    let next_monitor_min = 0;

    let updateInterval = setInterval(function () {
      count += 1;
      checkStatus();
    }, POLLING_INTERVAL);

    function checkStatus() {
      $.ajax({
        method: "GET",
        url: window.location.href + "/loading_status",
        data: {
          next_monitor_min: next_monitor_min,
        },
        success: function (response) {
          let status = response.status;
          next_monitor_min = response.next_monitor_min;

          if (status === "completed" || count > MAX_RETRIES) {
            completeAndRedirect(response.next_step);
            clearInterval(updateInterval);
          } else if (status === "expired" || status === "error") {
            completeAndRedirect(response.next_step);
            clearInterval(updateInterval);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (jqXHR.status === 404 || jqXHR.status === 500) {
            let response = JSON.parse(jqXHR.responseText);
            // Redirect
            window.location.href = response.redirect_url;
          }
        },
      });
    }

    document.addEventListener("turbo:before-visit", function () {
      clearInterval(updateInterval);
    });
  }
});

function toggleTextAndButtonVisibility() {
  const signingLink = document.getElementById("telia_sign_start_signing");
  const startSection = document.getElementById("telia_sign_start");
  const waitingSection = document.getElementById("telia_sign_waiting");

  if (signingLink) {
    signingLink.addEventListener("click", function () {
      startSection.classList.add("hidden");
      waitingSection.classList.remove("hidden");
    });
  }
}
